import loadable from '@loadable/component';
import { logError } from './log';

const getFilterIcon = (name) => {
  const AsyncIcon = loadable((props) => {
    try {
      return import(`../components/Icons/${props.name}`);
    } catch (e) {
      logError(e, 'get-filter-icon', {
        message: `Failed to load filter icon ${props.name}`,
      });
      return null;
    }
  });

  return <AsyncIcon name={name} />;
};

export default getFilterIcon;
